<script setup lang="ts">
import { ref, useId, watch } from 'vue';

const props = withDefaults(defineProps<{
    active?: boolean,
    name?: string
    activeColor?: string,
    inactiveColor?: string,
}>(), {
    active: false,
    name: undefined,
});
const emit = defineEmits<{ (e: 'change', value: boolean): void }>();

const checked = ref(props.active);

watch(() => props.active, (val) => {
    checked.value = val;
});

const emitChange = () => {
    emit('change', checked.value);
};

const id = useId();

defineExpose({ id });
</script>

<template>
    <label :for="id">
        <slot />
        <input :id="id" :name="name" type="checkbox" class="toggle" v-model="checked" @change="emitChange"
            :style="{ '--inactive-color': inactiveColor, '--active-color': activeColor }" />
    </label>
</template>

<style scoped>
label {
    display: flex;
    gap: 1rem;
    align-items: center;
    color: inherit;
}

input {
    cursor: pointer;
    appearance: none;
    position: relative;
    display: inline-block;
    background: lightgray;
    height: 1.65rem;
    width: 2.75rem;
    vertical-align: middle;
    border-radius: 2rem;
    box-shadow: 0px 1px 3px #0003 inset;
    transition: 0.1s linear background;
}

input::before {
    content: '';
    display: block;
    width: 1.25rem;
    height: 1.25rem;
    background: white;
    border-radius: 1.2rem;
    position: absolute;
    top: 0.2rem;
    left: 0.2rem;
    box-shadow: 0px 1px 3px #0003;
    transition: 0.1s linear transform;
    transform: translateX(0rem);
}

:checked {
    background: var(--active-color, var(--color-orange));
}

input:not(:checked) {
    background: var(--inactive-color, lightgray);
}

:checked::before {
    transform: translateX(1.1rem);
}
</style>